import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 7,
    government: 7,
    office: 10,
  },
  education: {
    childcare: 0,
    high_school: 0,
    library: 5,
    primary: 0,
    university: 5,
  },
  essentials: {
    electricity: 15,
    gas: 10,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 15,
    fast_food: 15,
    restaurant: 15,
  },
  health: {
    clinic: 10,
    dentist: 5,
    hospital: 5,
    pharmacy: 10,
  },
  nature: {
    beach: 5,
    forest: 5,
    lake: 7,
    mountain: 5,
    park: 10,
    river: 7,
  },
  religion: {
    church: 5,
    mosque: 5,
  },
  shops: {
    grocery: 10,
    mall: 15,
  },
  soil: {
    clay: 7,
    loam: 10,
    peat: 5,
    salt: -5,
    sand: 7,
    silt: 5,
  },
  sport: {
    gym: 5,
    pool: 10,
  },
  telecom: {
    cable_tv: 10,
    fiber_optic: 15,
    network_4g: 15,
    network_5g: 12,
    phone: 15,
  },
  transport: {
    airport: 10,
    bus: 12,
    ferry: 7,
    gas_station: 10,
    metro: 15,
    parking: 10,
    taxi: 12,
    train: 15,
    tram: 15,
  },
};

export default PLACES_PROFILE;
